module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAkklEQVQokZXTQQ6DIBCF4WcXnkHTxHgSPV937WHaA3Vr9Aq/C6VQRAZfMhuYLyQwCKiBFzDzHwWVjIBnZs/E7sQP0EYorgGYQuxSCscULoW6gh0c4juwcAr+Kof7HARUAWhLpWM6Sd/E+gYMfBYk6XYBHBLittA0/nw/YW+gMd77vvcBzLnZtvIQ/lcthWjZ++sV1UxJtOopNpYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/share3.png
// module id = vUOd
// module chunks = 1